import { Controller } from '@hotwired/stimulus';

export const READY_EVENT = 'cm_cmp_provider_ready';
export const CONSENT_STUDIO_PROVIDER = 'consent_studio';

export function providerFromDataLayer(dataLayer) {
  if (!Array.isArray(dataLayer)) {
    return null;
  }

  for (let index = dataLayer.length - 1; index >= 0; index -= 1) {
    const entry = dataLayer[index];
    if (entry && Object.prototype.hasOwnProperty.call(entry, 'cm_cmp_provider')) {
      return entry.cm_cmp_provider;
    }
  }

  return null;
}

export function pushProviderReadyEvent(provider) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: READY_EVENT,
    cm_cmp_provider: provider,
  });
}

// Signals GTM after Convert sets cm_cmp_provider. Consent Studio itself is
// injected by the GTM Consent Studio CMP tag — not by this controller.
// Native banner for non-variation traffic stays Convert's responsibility.
export default class extends Controller {
  connect() {
    this.activated = false;
    this.originalPush = null;

    window.dataLayer = window.dataLayer || [];
    this.observeDataLayer();
    this.handleProvider(providerFromDataLayer(window.dataLayer));
  }

  disconnect() {
    this.teardownDataLayerObserver();
  }

  observeDataLayer() {
    const dataLayer = window.dataLayer;
    this.originalPush = dataLayer.push.bind(dataLayer);

    dataLayer.push = (...args) => {
      const result = this.originalPush(...args);
      args.forEach((entry) => {
        if (entry && Object.prototype.hasOwnProperty.call(entry, 'cm_cmp_provider')) {
          this.handleProvider(entry.cm_cmp_provider);
        }
      });
      return result;
    };
  }

  teardownDataLayerObserver() {
    if (this.originalPush && window.dataLayer) {
      window.dataLayer.push = this.originalPush;
    }
  }

  handleProvider(provider) {
    if (provider !== CONSENT_STUDIO_PROVIDER || this.activated) {
      return;
    }

    this.activated = true;
    pushProviderReadyEvent(CONSENT_STUDIO_PROVIDER);
  }
}
